import { render } from "./HeroiconsOutlineReceiptRefund.vue?vue&type=template&id=7311c2e7"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineReceiptRefund.vue"]])

export default __exports__